export const humanizeVariableName = (name: string): string => {
  const words = name.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim()
  if (words.length === 0) {
    return name
  }
  return words.charAt(0).toUpperCase() + words.slice(1)
}
